import React, { FC, useState } from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { IResult } from '../../../../../../../../store/admin/roundResults/store';

import { IResultsByHole } from './HorseRaceTableBody';

interface IProps {
  hole: string;
  index: number;
  scoreFieldName: keyof IResult | undefined;
  resultsByHole: IResultsByHole;
}

export const HorseRaceTableRow: FC<IProps> = props => {
  const { hole, index, scoreFieldName, resultsByHole } = props;

  const [collapsedRow, setCollapsedRow] = useState<null | number>(null);

  const onClick = (rowIndex: number) => () =>
    setCollapsedRow(collapsedRow === rowIndex ? null : rowIndex);

  return (
    <>
      <TableRow
        className="results-table-table-body-row"
        id={`clickableRowResult-${index}`}
        key={`tableRowResult-${index}`}
        onClick={onClick(index)}
      >
        <TableCell className="index">{Number(hole) + 1}</TableCell>

        <TableCell className="playerName">{`${
          resultsByHole[hole].length
        } players eliminated`}</TableCell>

        <TableCell className="result" colSpan={3}>
          {scoreFieldName && resultsByHole[hole][resultsByHole[hole].length - 1][scoreFieldName]}
        </TableCell>
      </TableRow>

      <TableRow
        className="expandable-row results-table-table-body-row-expandable"
        key={`hiddenTableRow-${index}`}
      >
        <TableCell />

        <TableCell
          className="inner-cell"
          colSpan={4}
          classes={{ root: 'leaderboard-row-event-summary' }}
        >
          <Collapse
            className={`collapse-${index}`}
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={collapsedRow === index}
            timeout="auto"
            unmountOnExit={true}
          >
            {resultsByHole[hole].map((player: any, expandedIndex: number) => (
              <div className="eliminated-player-row" key={`collapse-item-${expandedIndex}`}>
                {`${player.userFirstName[0]}. ${player.userLastName}`}
              </div>
            ))}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
